import { useNetwork } from '@/presentation/context/network';
import { Address } from 'viem';
import Icon, { Icons } from '../Icon';
import VaultIcon from '../VaultIcon';
import { isAddressWeth } from '@/domain/ticks/helpers';

const PoolIcon = ({
  id,
  vaultId,
  symbol,
  size = 'small',
}: {
  id?: Address;
  vaultId?: string;
  symbol?: string;
  size?: 'small' | 'large';
}) => {
  const { network } = useNetwork();
  if (isAddressWeth(id, network)) {
    return (
      <Icon
        name={Icons.ETH}
        size={size == 'small' ? 24 : 48}
        className={`border border-gray-300 ${
          size === 'small' ? 'p-0.5' : 'p-1'
        } rounded-full bg-gray-50 text-gray-800 flex-none inline-block`}
      />
    );
  }

  return (
    <VaultIcon
      vaultId={vaultId}
      className={`${
        size == 'small' ? 'h-6 w-6' : 'h-12 w-12'
      } rounded-full flex-none inline-block`}
      alt={symbol}
    />
  );
};

export default PoolIcon;
